'use client'

import { useLoginAndReturnLink } from '@tebuto/functions/links'
import { cn } from '@tebuto/lib/utils'
import { Button } from './Button'

export default function LoginButton({
    title = 'Anmelden',
    app,
    className = ''
}: {
    title?: string
    app: 'client' | 'app' | 'landing'
    className?: string
}) {
    const loginLink = useLoginAndReturnLink(app)
    return (
        <Button
            className={cn(
                'lg:w-125 wrap-break-word! whitespace-normal! h-auto! flex flex-wrap items-center px-2 py-1 hover:cursor-pointer hover:shadow font-medium text-white',
                className
            )}
            href={loginLink}
        >
            {title}
        </Button>
    )
}
